import React from 'react';

import FormVipAppLeadList from '../FormVipAppLeadList';
import { FeatureSection as ADSFeatureSection } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

export default function FeatureSection(props) {
    return (
        <ADSFeatureSection
            {...props}
            ThisButtonComponent={ButtonComponent}
            FormVipAppLeadList={FormVipAppLeadList}
        />
    );
}
